<template>
  <div>
    <div style="z-index: 2" id="ordersmap" ref="ordersmap" :style="{ height: height + 'px', minHeight: '400px' }" />

    <div v-if="$parent.$parent.isDataLoading" class="api-loading-indicator">
      <i class="fas fa-sync-alt fa-spin" />
      <span class="ml-2">Updating...</span>
    </div>
  </div>
</template>

<script>
import "leaflet/dist/leaflet.css";
import { ChartsLeaf } from "@/my-leaf/charts/charts-leaf";
import { mapStores } from "pinia";
import { useMomentaryStore } from "@/stores/momentary";
import { useRoutesStore } from "@/stores/routes";
import { loadMSSChartsByRoute, loadMSSDataByRoute, loadDatasetByLegs } from "@/helpers/api";
import { useCatalogsStore } from "@/stores/catalogs";
import { useCartStore } from "@/stores/cart";
import { useDeviceStore } from "@/stores/device";

export default {
  props: ["height", "showRoute"],
  data() {
    return {
      ordersMap: null,
      availablePeriods: ["4", "1", "0"],
    };
  },
  mounted() {
    console.log("OrdersMap: mounted()");

    console.log("OrdersMap: ChartsLeaf init");
    this.ordersMap = new ChartsLeaf();
    this.ordersMap.init(this.$refs.ordersmap, this.showRoute, true);
  },
  computed: {
    ...mapStores(useMomentaryStore, useRoutesStore, useCatalogsStore, useCartStore, useDeviceStore),
    // currentCartLen() {
    //   return this.$store.state.current.cart.s63cells.length
    // },
  },
  beforeDestroy() {
    console.log("OrdersMap: начинаем очистку, ordersMap существует:", !!this.ordersMap);

    // Очищаем Leaflet карту и освобождаем ресурсы
    if (this.ordersMap) {
      try {
        // Используем метод destroy для полной очистки, включая контролы карты
        this.ordersMap.destroy();
        this.ordersMap = null;

        console.log("OrdersMap: карта и ресурсы очищены успешно");
      } catch (error) {
        console.warn("OrdersMap: ошибка при очистке карты", error);
      }
    }
  },
  methods: {
    init_map() {
      return new Promise((resolve) => {
        if (this.catalogsStore.getProductsCount > 0) {
          this.ordersMap.drawAllCells(this.catalogsStore.getItems);

          // Если есть маршрут, показываем его на карте
          if (this.routesStore.getShipWaypointsCount > 0) {
            this.ordersMap.showRoute();
          }

          this.clearOrder();
        } else {
          alert("ERROR: No catalog data available");
        }
        resolve();
      });
    },

    ordersTableMethods(key, id) {
      switch (key) {
        case "onCellClickedOrdersTable":
          // имитируем событие клика по ячейке
          this.ordersMap.onCellClicked(id);
          break;
        case "onCellClickedComplexOrdersTable":
          // имитируем событие клика по ячейке сложного продукта
          this.ordersMap.onCellClicked(id, true);
          break;
        case "onReplaceCellOrdersTable": {
          // для включения подсветки ячейки обратно после того, как она была выключена
          // TODO возможно переделать или убрать
          const m = this.ordersMap.match(id);
          const scope = m.scope;
          const field = m.field;
          // Мы пропускаем обновление стора в replaceCell, так как он уже обновлен в OrdersTable
          this.ordersMap.replaceCell(scope, field, id, false, true);
          break;
        }
        default:
          console.warn("OrdersMap: unknown method key", key);
      }
    },

    // Выбор публикаций по маршруту
    // TODO
    // selectPubsByRoute() {
    //   let enp = this.momentaryStore.getENPByRoute
    //   console.log('OrdersMap: selecting ENP by route', enp)
    //   this.cartStore.addENPByRoute()

    //   let adp = this.momentaryStore.getADPByRoute
    //   console.log('OrdersMap: selecting ADP by route', adp)
    //   this.cartStore.addADPByRoute()
    // },

    // prepareCells() {
    //   alert(3)
    //   return new Promise(resolve => {
    //     let points = []
    //     this.routesStore.getShipWaypoints.forEach(item => {
    //       points.push({ lat: item.lat, lon: item.lon })
    //     })

    //     if (this.deviceStore.getAgreementProvider === 'UKHO') {
    //       loadMSSDataByRoute(points).then(() => {
    //         console.log('OrdersMap: loaded UKHO data by route')
    //         if (this.currentCartLen === 0) {
    //           this.selectCellByRoute().then(() => {
    //             resolve()
    //           })
    //         } else {
    //           resolve()
    //         }
    //       })
    //     } else if (this.deviceStore.getAgreementProvider === 'Primar') {
    //       loadMSSChartsByRoute(points).then(() => {
    //         console.log('OrdersMap: loaded Primar charts by route')
    //         if (this.currentCartLen === 0) {
    //           this.selectCellByRoute().then(() => {
    //             resolve()
    //           })
    //         } else {
    //           resolve()
    //         }
    //       })
    //     }
    //   })
    // },

    clearOrder() {
      this.cartStore.clear();
    },
  },
};
</script>

<style>
#ordersmap {
  border: solid 1px dimgray;
}

.leaflet-interactive:hover {
  stroke: #ffa011;
  stroke-width: 4;
}

.api-loading-indicator {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: rgba(60, 60, 60, 0.7);
  color: white;
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 0.9em;
  z-index: 1050;
  display: flex;
  align-items: center;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  animation: fadeIn 0.3s ease-in-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.api-loading-indicator i {
  margin-right: 6px;
}
</style>
